// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"e88610a7","348":"aa6ad42f","764":"c29819eb","821":"5d53c115","822":"97fd0e71","852":"dd4eb84f","908":"1dcf482d","937":"3a9f5ded"}[chunkId] + ".chunk.js";
};